import React, { useState } from 'react'

// eslint-disable-next-line react/display-name
export default (props) => {
  const [editing, setEditing] = useState(false)
  const [fields, setFields] = useState(props.fields)

  const toggleEditing = () => {
    if (editing) {
      const thereAreChanges = Object.keys(fields)
        .map((f) => fields[f].value !== props.fields[f].value)
        .filter((change) => change !== false).length

      if (thereAreChanges) {
        const modifiedFields = {}

        Object.keys(fields).forEach((fieldKey) => {
          modifiedFields[fieldKey] = fields[fieldKey].value
        })

        props.onDone(modifiedFields)
      }

      setEditing(false)
    } else {
      setEditing(true)
    }
  }

  const handleChange = ({ target }) => setFields({ ...fields, [target.name]: { value: target.value } })

  const handleKeyPress = (e) => e.key === 'Enter' && toggleEditing()

  return (
    <div className={props.className || ''}>
      {editing ? (
        <div className='editing-area row'>
          {Object.keys(fields).map((fieldKey) => (
            <div key={fieldKey} className='col'>
              <input
                className='form-control'
                type={fields[fieldKey].type}
                value={fields[fieldKey].value}
                onChange={handleChange}
                name={fieldKey}
                onKeyPress={handleKeyPress}
              />
            </div>
          ))}
          <i className='fa fa-check' onClick={toggleEditing} />
        </div>
      ) : (
        <div className='click-to-edit' onClick={toggleEditing}>
          {props.children}
        </div>
      )}
    </div>
  )
}
